import { ChargerListRequest } from "../../../core/cms-api/models";
import * as paginationConstants from "../../../shared/constants/pagination.constants";
import { Pagination } from "../../../shared/models/list.page.model";
import { ChargerFilter } from "../store/charger.models";


export class ChargerRequestUtil {
    static createChargerListRequest(operatorId: string, pagination?: Pagination | null, filter?: ChargerFilter | null): ChargerListRequest {
        return {
            operatorId: operatorId,
            pageIndex: pagination?.pageIndex ?? 0,
            pageSize: pagination?.pageSize ?? paginationConstants.DefaultPageSize,
            plZs: filter?.plZs,
            chargerIds: filter?.chargerIds,
            cities: filter?.cities,
            countries: filter?.countries,
            streets: filter?.streets,
            serialNumbers: filter?.serialNumbers,
            powerRangeMax: filter?.chargingPowers ? filter.chargingPowers[1] : undefined,
            powerRangeMin: filter?.chargingPowers ? filter.chargingPowers[0] : undefined,
            connectionStatuses: filter?.connectionStatuses,
            powerTypes: filter?.powerTypes
        } as ChargerListRequest
    }
}